// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component, Input, Output, EventEmitter, ViewChildren, ElementRef, QueryList, OnChanges, SimpleChanges }
  from '@angular/core';
import { AlertDialogComponent } from 'src/app/dialogs/alert/alert.component';
import { MatDialog } from '@angular/material/dialog';
import { ID3EPolicy } from 'src/types/d3ePolicy';
import { NotificationService } from 'src/services/notification-service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-path-list',
    templateUrl: './path-list.component.html',
    styleUrls: ['./path-list.component.scss'],
    standalone: false
})
export class PathListComponent implements OnChanges {
  @Input() paths: string[];
  @Input() d3ePolicy: ID3EPolicy;
  @Input() dupeCertificate : boolean;
  @Output() changed: EventEmitter<void> = new EventEmitter<void>();
  @Output() enable: EventEmitter<void> = new EventEmitter<void>();
  @Input() disabled = false;
  @ViewChildren('pathInput', { read: ElementRef}) pathInputs: QueryList<ElementRef>;

  fErrorSimilarApp: string;

  constructor(
    public dialog: MatDialog,
    private notification: NotificationService,
    private translate: TranslateService
  ) {
        this.translate.get(['PATH_LIST_ERROR_SIMILAR_APP']).subscribe(vals => {
          this.fErrorSimilarApp = vals['PATH_LIST_ERROR_SIMILAR_APP'];
        });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.disabled && !changes.disabled.currentValue && changes.disabled.previousValue) {
      this.addPath();
    }
  }

  addPath() {
      this.paths.push('');
      this.changed.emit();
      if (this.paths.length === 1) {
        this.enable.emit();
      }
      setTimeout(this.focusNewPath.bind(this), 0);
  }

  focusNewPath() {
    this.pathInputs.last.nativeElement.focus();
  }

  deletePath(i: number) {
    if (this.paths[i].length === 0) {
      this.paths.splice(i, 1);
      this.changed.emit();
      return;
    }
    const title = this.translate.instant('DELETE_PATH');
    const yes = this.translate.instant('YES');
    const no = this.translate.instant('NO');
    const content = this.translate.instant('DELETE_PATH_CONTENT', {path: this.paths[i]});
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      width: '450px',
      data: {
        title: `${title}?`,
        content: content,
        rejectBtnName: no,
        acceptBtnName: yes,
        showRejectBtn: true,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.paths.splice(i, 1);
        this.changed.emit();
      }
    });
  }

  isDupePath(e, i) {
    const code = (e.keyCode);
    // do nothing if it's non-printable chars, at least most
    if (code < 40 || (code > 95 && code < 112)) {
        return;
    }

    // Flatten the path arrays for all known good apps
    const paths = [].concat.apply([], this.d3ePolicy.knownGood.map(kg => kg.paths));
    if (paths.filter(p => p.toLocaleLowerCase() === this.paths[i].toLocaleLowerCase()).length > 1) {
      this.showDupeWarning();
    }
  }

  showDupeWarning() {
    this.notification.showError(this.fErrorSimilarApp);
  }

  trackByIdx(index: number): any {
    return index;
  }
}
